module.exports = __webpack_public_path__ + "img/dashboard-approve.dfab563e.svg";